import { render, staticRenderFns } from "./HospitalReportingData.vue?vue&type=template&id=5dca61fa"
import script from "./HospitalReportingData.vue?vue&type=script&lang=js"
export * from "./HospitalReportingData.vue?vue&type=script&lang=js"
import style0 from "./HospitalReportingData.vue?vue&type=style&index=0&id=5dca61fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports